import { oz } from '@weft/utils';
import { ApiDateSchema, ObjectIdSchema } from '../../primitives';

export const CreditLedgerEntryOverviewSchema = oz.object({
  id: oz.string(),
  date: ApiDateSchema,
  invoiceId: ObjectIdSchema.nullish(),
  debitAmount: oz.number().optional(),
  creditAmount: oz.number().optional(),
  balance: oz.number(),
}).openapi('CreditLedgerEntryOverview');

export type CreditLedgerEntryOverview = oz.TypeOf<typeof CreditLedgerEntryOverviewSchema>;
